<template>
  <!-- <el-card style="margin-bottom: 20px;"> -->
    <el-row :gutter="20">
      <!-- <el-col
        class="hidden-xs-only"
        :xs="24"
        :sm="8"
        :md="8"
      >
        <el-card
          style="text-align: center; cursor: pointer;"
          shadow="hover"
          @click.native="$emit('show-big-img')"
        >
          <img
            :src="referenceUrl"
            width="100%;"
          >
          <div style="font-size: small;">{{$t('guestID.refImgDesc')}}</div>
        </el-card>
      </el-col> -->

      <el-col
        :xs="24"
        :sm="16"
        :md="16"
      >
        <!-- <div
          style="padding: 0px 0px 20px 0px;"
          v-for="(history, i) in historys"
          :key="i"
        >
          <div>
            <el-card
              :body-style="{ padding: '8px'}"
              style="width: 120px; display: inline-block; cursor: pointer;"
              @click.native="$emit('show-big-img', history.imgUrl)"
            >
              <img
                :src="history.imgUrl"
                width="100%;"
                :v-loading="referenceUrl"
              >
            </el-card>
          </div>

          <div style="padding: 10px 0px 0px 0px;">
            <span style="vertical-align: middle; color: #909399; font-size: small; ">Current Status：&nbsp;&nbsp;</span>
            <el-tag
              size="medium"
              :type="tagType(history.status)"
            >{{$t('guestID.uploadStatus.' + history.status)}}</el-tag>
          </div>
        </div> -->
        <!--上传插件-->
        <div style="width: 100%;" class="upload-box">
          <customer-upload
            :upload-dir="config.uploadFolder"
            :file-list.sync="config.fileList"
            @getFileKey="getFileKey"
            :file-size="8"
            :file-type="['jpg', 'jpeg', 'png', 'gif']"
            :desc="$t('guestID.uploadRule')"
            list-type="picture"
            :imgInfo="imgInfo"></customer-upload>
          <span @click="bigImgDialogVisible = true">{{$t('guestID.viewExample')}}</span>
        </div>
        <div class="el-upload__tip">{{$t('guestID.uploadRule') }}</div>
      </el-col>
      <el-dialog
        :visible.sync="bigImgDialogVisible"
        :show-close="true"
        :title="$t('guestID.refImgDesc')"
        top="20px"
        width="90%"
        append-to-body
        modal-append-to-body>
          <img width="100%" style="max-width: 500px; display: block; margin: 0px auto;" :src="bigImgDialogUrl">
        </el-dialog>
    </el-row>
  <!-- </el-card> -->
</template>

<script>
import CustomerUpload from '@/components/CustomerUpload'
// import { result } from '@/api/identification'

export default {
  name: 'Upload',
  props: {
    referenceUrl: String,
    openOrderId: String,
    imgInfo: Object,
    index: Number,
  },
  components: {
    CustomerUpload,
  },
  data () {
    return {
      config: {
        ossDomain: null,
        uploadFolder: 'guest_id',
        uploadTimeOutMillisecond: 30 * 1000,
        fileList: [],
      },
      historys: [],
      ossClient: null,
      bigImgDialogVisible: false,
      bigImgDialogUrl: 'https://ostay-open-img.oss-ap-northeast-1.aliyuncs.com/resources/img/open/reference/passport.jpg',
    }
  },
  methods: {
    // handleSuccess (e) {
    //   console.log(e)
    //   this.$emit('successHandle', e)
    // },
    loadHistory () {
      console.log('客户证件-详情')
      // const info = this.$cookie.getCustomerInfo()
      // result({
      //   token: info.token || '',
      // }).then(res => {
      //   if (res.errCode === '200') {
      //     const result = res.data
      //     if (!result) {
      //       this.historys = []
      //       return
      //     }
      //     this.historys = [{ imgUrl: result.imgUrl, status: result.status }]
      //     this.$emit('upload-success')
      //   } else {
      //     this.$message.error(res.errCode + ': ' + res.errMsg)
      //     this.historys = []
      //   }
      // })
    },
    getFileKey (fileKey) {
      console.log(this.index)
      this.$emit('successHandle', { ...fileKey, index: this.index })
    },
    tagType (status) {
      let type = ''
      switch (status) {
        case 'WAIT':
          type = 'warning'
          break
        case 'PASS':
          type = 'success'
          break
        case 'REJECTED':
          type = 'danger'
          break
        default:
          type = 'primary'
      }
      return type
    },
  },
  created () {
    this.loadHistory()
  },
}
</script>

<style lang="scss" scoped>
.upload-box{
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 10px;
  span {
    cursor: pointer;
    color: #B59429;
    text-decoration-line: underline;
    font-size: 14px;
  }
}
</style>
